import { render, staticRenderFns } from "./AprovacaoCobranca.vue?vue&type=template&id=76464bdd&"
import script from "./AprovacaoCobranca.vue?vue&type=script&lang=js&"
export * from "./AprovacaoCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports